<template>
  <div :key="uid + ''"
    class="search-item"
  >
    <slot name="before"></slot>
  
    <span :class="{ske, 'forced-ske': forcedSke}">
      {{ domainname }}
    </span>
  </div>
</template>

<script>

export default {
  props: {
    uid: [String, Number],
    domainname: String,
    forcedSke: Boolean,

    ske: Boolean,
  },
}

</script>

<style scoped>

.search-item {
  background-color: white;
  transition-duration: .2s;
  padding: 3px 6px; 
  transition-timing-function: ease-in-out;
}

.search-item:hover {
  background-color: rgba(243, 244, 246, 1) !important;
  cursor: pointer;
}

</style>
